module.exports = __webpack_public_path__ + "img/certificate-pattern-bg.1984bedf.png";